export enum AlertType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export enum AlertLayout {
  Row = 'row',
  Column = 'column',
}
